<template lang="pug">
    div( class="text-xs-center" full-width )
        v-dialog( v-model="open" max-width="80%" fullscreen hide-overlay )
            v-card
                v-toolbar( color="grey darken-4" dark sticky flat )
                    v-btn( icon dark @click="open = false" )
                        v-icon close
                    v-toolbar-title Seleccione Productos
                div
                    crud-form(:fields="formFields" noPadding  noButtons @autocompleteObjSelectId="handleSelectCrudForm($event)" @submitForm='submitForm' ref="linkProductDialogForm")
                        crud-data-table.mx-5.products-dialog-picker(noAutoWidth checkable :headers="ocHeaders" noActions noButtons  ref="ocSelectedDataTable" :service="service" slot="appendContent" )
                v-divider        
                v-layout.white
                    v-spacer
                    v-btn( color="primary" dark @click="submitDialog" ) agregar productos
</template>

<script>
//
import { CrudDataTable, CrudForm } from '@/components/reusable_components'


import FamilyMdl from '@/models/Warehouse/WhFamily'
import SubfamilyMdl from '@/models/Warehouse/WhSubfamily'
import ProductMdl from '@/models/Warehouse/WhProduct'
import TagMdl from '@/models/Warehouse/WhTag'
// Services
import { fetch } from '@/services/api/DataFetch'
// Mixins
import getDataFromRequestResponse from '@/mixins/GetDataFromRequestResponse'
import {
    generateFetchDataFunction,
} from '@/services/api/DataTableService'


import HeaderPicker from '@/views/provider/table/ProductPickerDialogHeader'
//
import { mapState, mapActions } from 'vuex'
import ProviderLinkProductsFields from '@/views/provider/form/ProviderLinkProductsFields'
import subFamilyService from '../../services/api/subfamily/SubfamilyService.js'
export default {
    name: 'link-product-dialog',
    props: {
        

        
        providerId: {
            type: Number,
            default: () => null,
        },
        /*
         *
         */
        mainTittle: {
            type: String,
            default: 'Seleccionar productos',
        },
    },
    components: {
        'crud-data-table': CrudDataTable,
        'crud-form' : CrudForm,
    },
    data() {
        return {
            ocHeaders: HeaderPicker,
            service: {
                dtFetchData: () => {},
            },
            open: false,
            // Family select
            familyList: [],
            selectedFamily: null,
            // Tags select
            tagsList: [],
            selectedTags: null,
            // Subfamily select
            subfamilyList: [],
            selectedSubfamily: null,
            
            //
            formFields:ProviderLinkProductsFields
        }
    },
    computed: {
        /**
         *
         */
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        /*
         *
         */
        tableHasData() {
            return false
        },
    },
    methods: {
        /**
         *
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        /* 
            
            */
        setOpen(open) {
            this.open = open
            this.resetFilters()
        },
        /* 
            
            */
        submitDialog() {
            this.showSnackbar(
                'warning',
                'Asociar Producto',
                'Estas Seguro de querer asociar los productos seleccionados',
                () => this.setMessageConfirmSnack('Asociar')
            )
            
        },
        /* 
            
            */
        async getSubfamilyList(familyId) {
            // Get Subfamily
            let options = this.getOptionsSubfamilyRequest(familyId)
            let responseSubFamily = await fetch(SubfamilyMdl, options)
            this.subfamilyList = this.getDataFromRequestResponse(
                responseSubFamily
            )
        },
        /**
         * 
         */
        sendProducts(){
            this.open = false
            this.$emit('submit', {
                selected: [...this.$refs.ocSelectedDataTable.selected],
            })
            this.$refs.ocSelectedDataTable.selected = []
            this.resetFilters()
        },
        /* 
            
            */
        getOptionsSubfamilyRequest(familyId) {
            // get all results param
            return {
                params: {
                    get_all_results: true,
                },
                filters: [
                    {
                        field: 'wh_family_id',
                        value: familyId,
                    },
                ],
            }
        },
        /* 
            
            */
        resetFilters() {
            //
            this.$refs.linkProductDialogForm.$refs.form.reset()
               
            //
        },
        /* 
            
            */
        async getSubfamilyList(familyId) {
            // Get Subfamily
            let options = this.getOptionsSubfamilyRequest(familyId)
            let responseSubFamily = await fetch(SubfamilyMdl, options)
            this.subfamilyList = this.getDataFromRequestResponse(
                responseSubFamily
            )
        },
        /* 
            
            */
        fetchDataWhProduct() {
            this.service.dtFetchData = generateFetchDataFunction(
                this.getWhProductModelWithFilters(),
                [],
                ['stocks']
            )
        },
        /* 
            
            */
        getWhProductModelWithFilters() {
            let model = ProductMdl
            
                if (this.selectedFamily !== null)
                    model = model.where('wh_family_id', this.selectedFamily)
                if (this.selectedSubfamily !== null)
                    model = model.where(
                        'wh_subfamily_id',
                        this.selectedSubfamily
                    )
                if (this.selectedTags !== null)
                    model = model.whereIn('tags_id', this.selectedTags)
                return model.append('name_product', 'upc_code_product')
            
        },
        /**
         *
         */
        async showSnackbar(type, title, message, callback = () => {}) {
            //
            this.resetSnackbarState()
            this.initSnackbar(this.fillSnack(type, title, message, false, 3000))
            callback()
        },
        /**
         * 
         */
        async handleSelectCrudForm(event){

            let fields = [...this.formFields]
            if(event.type==='family' && event.id){
                let response = await subFamilyService.fetchByFamily(event.id)
                fields[2].options.data = response
                fields[1].value = event.id
                this.selectedFamily = event.id
            }
            else if( event.type === 'subfamily' && event.id){
                this.selectedSubfamily = event.id
            }
            else if( event.type === 'tag' && event.id){
                this.selectedTags = event.id
            }
            this.fetchDataWhProduct()    
            this.formFields = [...fields]
        },
        /**
         * 
         */
        async fillFormWithData(){
            //
            let fields = [...this.formFields]
            let options = {
                params: {
                    get_all_results: true,
                },
            }
            
            let responseTags = await fetch(TagMdl, options)
            let responseFamily = await fetch(FamilyMdl, options)
            //
            fields[0].options.data = this.getDataFromRequestResponse( responseTags )
            fields[1].options.data = this.getDataFromRequestResponse( responseFamily )

            this.formFields = [...fields]
        },
    },
    watch: {
        /**
         * 
         */
        async selectedFamily(val) {
            this.getSubfamilyList(val)
            this.fetchDataWhProduct()
        },
        /* 
            
            */
        selectedSubfamily(val) {
            this.fetchDataWhProduct()
        },
        /* 
            
            */
        selectedTags(val) {
            this.fetchDataWhProduct()
        },
        /**
         *
         */
        async responseConfirm(message) {
            switch (message) {
                case 'Asociar':
                    return this.sendProducts()
            }
        },
    },
    beforeMount: async function() {
        this.fetchDataWhProduct()
        this.fillFormWithData()
    },
    mixins: [getDataFromRequestResponse],
}
</script>

<style>
.products-dialog-picker .full-width-datatable .v-table__overflow {
    max-height: 35vh;
    overflow-y: auto;
}
.v-dialog {
    background: white;
}
</style>
